import React from 'react'
import { Button, Drawer, Table, Tag, Tooltip } from 'antd'
import moment from 'moment'
import AuthService from '../auth/AuthService';
import 'jspdf-autotable';
import { styled } from '@mui/material';
import { showMessage } from '../Utils/message';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { netsuite_url } from '../config';
import { useNavigate } from 'react-router-dom';
import { encodeId } from '../common/CommonFun';
import Papa from "papaparse";

const Auth = new AuthService();
const TableSheet = styled('div')`
   
    .ant-input-outlined[disabled] {
      background-color: none;
      color: black;
      font-weight: 500;
    }
`;

const StockTrailDrawer = ({ drawerOpen, drawerClose, stockTrail, selectedStockRecord, selectedItem}) => {
    const { locations, roles } = useSelector((state) => state?.AppState?.userCreds);
    const navigate = useNavigate();

    const stockItemsCol = [
      {
          title: "Date",
          render: (record) => {
            return (
              <>
                {record?.posting_date ? moment(record?.posting_date).format('DD-MM-YYYY') : ""}
              </>
            )
          },
          // width: 100
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          // width: 100,
        },
           {
      title: 'Document No.',
      render: (record) => {
        const hasRole5 = roles?.some(r => r.role_id === 5);
    
        const getUrl = () => {
          if (record?.type === 'Sales Invoice') {
            return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
          }
          if (record?.type === 'Purchase Order') {
            return `${netsuite_url}/app/accounting/transactions/purchord.nl?id=${record?.transaction_id}`;
          }
          if (record?.type === 'Credit Note') {
            return `${netsuite_url}/app/accounting/transactions/custcred.nl?id=${record?.transaction_id}`;
          }
          if (record?.type?.includes("RouteOut")) {
          return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
          }
          if (record?.type?.includes("RouteReturn")) {
          return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
          }
          return null; // transfer cases handled separately
        };
    
        const isTransfer = record?.type === 'Transfer Stock';
        const isOb = record?.type === 'Opening Balance';
        
        return record?.transaction_id && record?.document_number ? (
          <>
    
            {hasRole5 ? (
              <>{record?.document_number}</>
            ) : isTransfer ? (
              <Tooltip title="View Details" placement="top">
                <span
                  onClick={() => navigate(`/transaction-transfer/${encodeId(record?.transaction_id)}`)}
                  style={{ color: "#2563eb", fontWeight: 600, cursor: "pointer" }}
                >
                  {record?.document_number}
                </span>
              </Tooltip>
            ) : isOb ? (
          <Tooltip title="View Details" placement="top">
            <span
              onClick={() =>{
                    const hasedID = encodeId(record?.transaction_id)
                  navigate(`/transaction-ob/${hasedID}`)
                }}
              style={{ color: "#2563eb", fontWeight: 600, cursor: "pointer" }}
            >
              {record?.document_number}
            </span>
          </Tooltip>
        ) : (
              <Tooltip title="View Details" placement="top">
                <a
                  href={getUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#2563eb", fontWeight: 600 }}
                >
                  {record?.document_number}
                </a>
              </Tooltip>
            )}
          </>
        ) : (
          "-"
        );
      },
      width: 120,
      align: 'center'
    },
    
        {
          title: "Name",
          render: (record) => {
            return (
              <>
                {record?.code ? `${record?.code} - ${record?.name}` : ""}
              </>
            )
          },
          // width: 150
        },
        {
          title: 'Location',
          render: (record) => {
            const selected = locations?.find((item) => item.id == record?.location_id)
            return (
              <>
                {selected?.code}
              </>
            );
          },
          width: 80
    
        },
        
        {
      title: 'Quantity',
      render: (record) => {
        const quantity = Number(record?.quantity) || 0;
        const color = quantity > 0 ? 'green' : 'red';
    
        return (
          <Tag color={color} style={{ fontWeight: 'bold' }}>
            {quantity}
          </Tag>
        );
      },
      align: 'center',
      width: 100
    },
    
        {
          title: "Batch Code",
          render: (record) => {
            return (
              <>
                {record?.batch_code ? record?.batch_code : ""}
              </>
            )
          },
          // width: 200
        },
         
        {
          title: "Sup. Batch Code",
          render: (record) => {
            return (
              <>
                {record?.supplier_batch_code ? record?.supplier_batch_code : ""}
              </>
            )
          },
          align: 'center',
          width: 140
        },
        // {
        //   title: "Expiry",
        //   render: (record) => {
        //     return (
        //       <>
        //         {record?.expiry_date ? moment(record?.expiry_date).format('DD-MM-YYYY') : ""}
        //       </>
        //     )
        //   },
        // },
        {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },
        
        {
          title: "Created At",
          render: (record) => {
            return (
              <>
                {record?.createdAt ? moment(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : ""}
              </>
            )
          },
          // width: 150
        },
        {
          title: 'User',
          dataIndex: 'user_name',
          key: 'user_name',
          // width: 150
        },
       
      ]
const handleExportCSV = () => {
      if (!stockTrail || stockTrail.length === 0) {
        showMessage("error", "No data to export");
        return;
      }
  
      // Define headers from table columns
      const headers = stockItemsCol.map(col => col.title);
  
      // Map data into rows
      const rows = stockTrail.map(record =>
        stockItemsCol.map(col => {
          if (col.dataIndex) {
            return record[col.dataIndex] ?? "";
          } else if (col.title === "Document No.") {
        return record?.document_number ?? "";
      } else if (col.render) {
            // Call render if it’s a function
            const rendered = col.render(record);
            if (typeof rendered === "string" || typeof rendered === "number") {
              return rendered;
            }
            if (rendered?.props?.children) {
              return Array.isArray(rendered.props.children)
                ? rendered.props.children.join(" ")
                : rendered.props.children;
            }
            return "";
          }
          return "";
        })
      );
  
      // Convert to CSV with PapaParse
      const csv = Papa.unparse({
        fields: headers,
        data: rows,
      });
  
      // Trigger browser download
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const todayDate = dayjs().format('DD-MM-YYYY');
      link.setAttribute("download", `Stock_Trail_${selectedItem?.code}_${todayDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
        <>
            <Drawer
                open={drawerOpen}
                onClose={drawerClose}
                height="100vh"
                title={`Stock Trail - ${selectedStockRecord}`
                }
                placement={"bottom"}
                bodyStyle={{ background: '#f5f5f5', padding: '10px', }}
                extra={
                    <Button type='primary' onClick={handleExportCSV}>Download</Button>
                }
            >
                
                <TableSheet>
                    <Table
                        dataSource={stockTrail}
                        pagination={false}
                        columns={stockItemsCol}
                        bordered
                        style={{ marginTop: "10px" }}
                        scroll={{x: 'max-content' }}
                        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                    />
                </TableSheet>
            </Drawer>
        </>
    )
}

export default StockTrailDrawer